import {Inject, Injectable} from '@angular/core';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from './api.service';
import {ToastrService} from "ngx-toastr";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {CookieService} from "ngx-cookie-service";



@Injectable({
  providedIn: 'root'
})
export class InternalService {
  public key: any;
  public isParent: any;
  darkContent = true
  constructor(@Inject(SESSION_STORAGE) private session: WebStorageService,
              public translate: TranslateService,
              private cookieService: CookieService,
              public apiService: ApiService,
              public toastr: ToastrService,) {
    if(this.apiService.currentDirection == 'rtl'){
      this.cookieService.set('lang' ,'1');
    }else{
      this.cookieService.set('lang' ,'2');
    }
  }


  changeLang(language: string, id) {
    if (language === 'fa-ir') {
      this.cookieService.set('lang', '1');
    } else {
      this.cookieService.set('lang', '2');
    }
    // the methode for change lang and direction of whole website
    this.translate.use(language);
    this.translate.get('dir', language).subscribe(
      (res) => {

        this.apiService.currentDirection = res;

        const dom: any = document.querySelector('body');

        if (res === 'rtl' && !dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 1);
          dom.classList.toggle('rtl');

          if (id !== 0) {
            window.location.reload();
          }
        }
        if (res === 'ltr' && dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 2);
          dom.classList.toggle('rtl');
          if (id !== 0) {
            window.location.reload();
          }

        }
      }
    );
  }




  showSuccess(message, title) {
    this.toastr.success(message, title);
  }

  showError(message, title) {
    this.toastr.error(message, title);
  }

}
